// Statische Mock-Daten – nur für Hero-Slider & Stats (alles andere kommt aus dem Backend)

export const heroSlides = [
  { highlight: "Unternehmens", word: "Webdesign" },
  { highlight: "E-Commerce", word: "Webdesign" },
  { highlight: "Persönliches", word: "Webdesign" },
  { highlight: "Produkt", word: "Webdesign" },
  { highlight: "Reise", word: "Webdesign" },
  { highlight: "Stiftung", word: "Webdesign" },
];

export const stats = [
  { number: "61.300.000", suffix: "+", label: "Geschriebene Codezeilen" },
  { number: "415.000", suffix: "+", label: "Einzigartige Webseiten" },
  { number: "860", suffix: "+", label: "Abgeschlossene Projekte" },
  { number: "2.100", suffix: "+", label: "Zufriedene Kunden" },
];

export const workSteps = [
  {
    color: "#2196F3",
    title: "Planung",
    desc: "Der Wunsch des Projektinhabers wird gründlich analysiert; basierend auf Erwartungen und Zielen wird mit der Umsetzung begonnen.",
    icon: "presentation",
  },
  {
    color: "#FF6B35",
    title: "Visuelles Design",
    desc: "Allgemeines Konzeptdesign und Unterseitenlayouts werden festgelegt, grafisches Design und Skelettstruktur werden erstellt.",
    icon: "palette",
  },
  {
    color: "#22C55E",
    title: "Programmierung",
    desc: "Code-Entwicklung, Anpassung der Codestruktur an das Design, Dateneingabe und Implementierung werden durchgeführt.",
    icon: "code",
  },
  {
    color: "#EF4444",
    title: "SEO-Optimierung",
    desc: "On-Page- und Off-Page-Optimierung des Projekts wird durchgeführt, um die besten Ergebnisse zu erzielen.",
    icon: "rocket",
  },
  {
    color: "#A855F7",
    title: "Tests & Qualität",
    desc: "Umfassende Tests auf allen Geräten, Browsern und Bildschirmgrößen, um eine fehlerfreie Erfahrung zu gewährleisten.",
    icon: "shield-check",
  },
  {
    color: "#06B6D4",
    title: "Veröffentlichung",
    desc: "Das Projekt wird auf den Live-Server übertragen, Domain und Hosting werden konfiguriert und die Website wird live geschaltet.",
    icon: "globe",
  },
];

export const features = [
  { title: "Originelles Design", desc: "Wir gestalten Ihre Website mit ungewöhnlichem, völlig anderem Originaldesign und einzigartigem Inhalt." },
  { title: "Vollständige Mobile-Kompatibilität", desc: "Mit responsivem Code stellen wir sicher, dass Ihre Website auf allen Geräten einwandfrei aussieht." },
  { title: "Sauberer Code", desc: "Im Gegensatz zu komplizierten Codes auf Ihrer Website schreiben wir sehr einfachen und webfreundlichen Code." },
  { title: "Geschwindigkeitsvorteil", desc: "Mit der modernsten und schnellsten Programmierinfrastruktur bieten wir Geschwindigkeit, die Sie zufrieden stellt." },
  { title: "Web-Optimierung", desc: "Damit sich die Suchmaschinen Ihrer Website nähern, bieten wir technische Optimierung." },
  { title: "SEO-Integration", desc: "Wir integrieren grundlegende SEO-Regeln in Ihre Website und sorgen für bessere Rankings in Suchmaschinen." },
];

export const reasons = [
  { title: "Erfahrenes Expertenteam", desc: "Unser professionelles Team mit über 10 Jahren Erfahrung produziert in jedem Projekt Ergebnisse, die ein hervorragendes Benutzererlebnis bieten." },
  { title: "Modernste Technologien", desc: "Mit aktuellen Technologien wie HTML5, CSS3, React, PHP und WordPress entwickelte Projekte sind sowohl sicher als auch nachhaltig." },
  { title: "Originelle, hochwertige Designs", desc: "Wir machen den Unterschied mit markenspezifischen, modernen und wirkungsvollen Webdesigns." },
  { title: "Schnelle Entwicklung", desc: "Mit leistungsorientierten Webentwicklungsprozessen optimieren wir die Ladezeit und SEO-Leistung Ihrer Website." },
  { title: "Kompetenz im Corporate Webdesign", desc: "Mit professionellen Webdesign-Lösungen, die Ihre Corporate Identity widerspiegeln, heben wir Ihre Marke in der digitalen Welt hervor." },
  { title: "Effektives Social-Media-Management", desc: "Wir planen Ihre Social-Media-Strategien markenspezifisch und stärken Ihre digitale Präsenz mit Kampagnen." },
  { title: "Maßgeschneiderte Lösungen", desc: "Jede Marke ist einzigartig. Wir entwickeln individuelle Software-, Design- und SEO-Lösungen für Ihre Bedürfnisse." },
  { title: "E-Commerce-Expertise", desc: "Wir gestalten benutzerfreundliche, mobiloptimierte und verkaufsorientierte E-Commerce-Websites." },
  { title: "Digital-Marketing-Dienste", desc: "Mit Google Ads, Meta-Anzeigen und Performance-Marketing-Strategien bringen wir Ihre Marke zur richtigen Zeit vor Ihre Zielgruppe." },
  { title: "SEO-Expertise", desc: "Mit SEO-Analysen, Keyword-Recherche und technischen Optimierungsprozessen erhöhen wir die Sichtbarkeit Ihrer Website." },
  { title: "12 Monate kostenloser Support", desc: "Ein ganzes Jahr lang technischer Support, Updates und Pflege – komplett kostenlos für jeden Kunden inklusive." },
  { title: "Wettbewerbsfähige Preise", desc: "Wir bieten hohe Qualität zu wettbewerbsfähigen Preisen bei Webdesign- und SEO-Diensten." },
];

export const navItems = [
  { label: "Start", href: "#top" },
  { label: "Leistungen", href: "#leistungen" },
  { label: "Hosting", href: "#hosting" },
  { label: "Domain Auktionen", href: "#domains" },
  { label: "Projekte", href: "#projekte" },
  { label: "Über uns", href: "#ueber" },
  { label: "Kontakt", href: "#kontakt" },
];

export const footerLinks = [
  "Unternehmens-Webdesign",
  "AMP-Webdesign",
  "Persönliche Website",
  "Produktwebsite",
  "E-Commerce-Website",
  "Reise & Organisation",
  "Stiftung & Verein",
  "Web-Software",
  "Web-Beratung",
  "Social-Media-Beratung",
  "Logo-Design",
  "Corporate Identity",
  "Suchmaschinenoptimierung",
  "Social-Media-Werbung",
  "Google Adwords",
  "Marken & Patentregistrierung",
];

// Service-Typen für Angebot-Wizard
export const serviceTypes = [
  { id: "corporate", label: "Unternehmens-Website", icon: "Building2" },
  { id: "ecommerce", label: "E-Commerce / Online-Shop", icon: "ShoppingBag" },
  { id: "personal", label: "Persönliche Website", icon: "User" },
  { id: "landing", label: "Landing-Page / Produkt", icon: "Rocket" },
  { id: "webapp", label: "Web-Anwendung / SaaS", icon: "Layers" },
  { id: "redesign", label: "Redesign / Relaunch", icon: "Sparkles" },
  { id: "seo", label: "SEO-Optimierung", icon: "Search" },
  { id: "ads", label: "Google / Social Ads", icon: "Megaphone" },
  { id: "branding", label: "Logo & Corporate Identity", icon: "Award" },
];

export const budgetRanges = [
  { id: "lt5k", label: "Bis 5.000 CHF" },
  { id: "5to10k", label: "5.000 – 10.000 CHF" },
  { id: "10to25k", label: "10.000 – 25.000 CHF" },
  { id: "25to50k", label: "25.000 – 50.000 CHF" },
  { id: "gt50k", label: "Über 50.000 CHF" },
  { id: "open", label: "Noch nicht festgelegt" },
];

export const timelineOptions = [
  { id: "asap", label: "So schnell wie möglich" },
  { id: "1month", label: "Innerhalb 1 Monat" },
  { id: "3months", label: "1 – 3 Monate" },
  { id: "6months", label: "3 – 6 Monate" },
  { id: "flexible", label: "Flexibel" },
];
